export default __webpack_public_path__ + "static/MenschCologne-0e3985db6ed6b962d458d5ff404c5b92.png";